const Settings = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d="M13 16.25C14.7949 16.25 16.25 14.7949 16.25 13C16.25 11.2051 14.7949 9.75 13 9.75C11.2051 9.75 9.75 11.2051 9.75 13C9.75 14.7949 11.2051 16.25 13 16.25Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.16663 13.9532V12.0466C2.16663 10.9199 3.08746 9.98822 4.22496 9.98822C6.18579 9.98822 6.98746 8.60156 6.00163 6.90072C5.43829 5.92572 5.77413 4.65822 6.75996 4.09489L8.63413 3.02239C9.48996 2.51322 10.595 2.81656 11.1041 3.67239L11.2233 3.87822C12.1983 5.57906 13.8016 5.57906 14.7875 3.87822L14.9066 3.67239C15.4158 2.81656 16.5208 2.51322 17.3766 3.02239L19.2508 4.09489C20.2366 4.65822 20.5725 5.92572 20.0091 6.90072C19.0233 8.60156 19.825 9.98822 21.7858 9.98822C22.9125 9.98822 23.8441 10.9091 23.8441 12.0466V13.9532C23.8441 15.0799 22.9233 16.0116 21.7858 16.0116C19.825 16.0116 19.0233 17.3982 20.0091 19.0991C20.5725 20.0849 20.2366 21.3416 19.2508 21.9049L17.3766 22.9774C16.5208 23.4866 15.4158 23.1832 14.9066 22.3274L14.7875 22.1216C13.8125 20.4207 12.2091 20.4207 11.2233 22.1216L11.1041 22.3274C10.595 23.1832 9.48996 23.4866 8.63413 22.9774L6.75996 21.9049C5.77413 21.3416 5.43829 20.0741 6.00163 19.0991C6.98746 17.3982 6.18579 16.0116 4.22496 16.0116C3.08746 16.0116 2.16663 15.0799 2.16663 13.9532Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Settings;
